// extracted by mini-css-extract-plugin
export default {"container":"App_container__cu9yO","main":"App_main__g-ZH2"};